import Twig from 'twig';
import Media from './../mediaDetect.js'; //Детектор медиа

var currPageGalleryDetail = 1;

let PressCenter = {
    Wallet: {
        initSlider: function(slider){
            let sliderMobileConfig = {
                centerMode: false,
                adaptiveHeight: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                pauseOnHover: true,
                pauseOnFocus: true,
                autoplay: false,
                speed: 800,
                fade: false,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }

            if(Media.detect().isMobile){
              slider.slick(sliderMobileConfig);
            }
            
            $(window).resize(function(event) {

                var initRoutesSlider = slider.hasClass('slick-slider');

                if(Media.detect().isMobile && (!initRoutesSlider)){
                    slider.slick(sliderMobileConfig);
                }
                
                if((!Media.detect().isMobile) && initRoutesSlider){
                    slider.slick('unslick');
                }
            });
        }
    },
    Gallery: {
        initPopupVideo: function(currBtn) {
            var currItem = currBtn.closest('[data-gallery-popup]'),
                typeItem = currItem.data('gallery-popup'),
                contentWrap = currItem.find('[data-wrap-content-gallery-popup]'),
                content = currItem.find('[data-content-gallery-popup]');

            $.magnificPopup.open({
                items: {
                    src: contentWrap
                },
                type: 'inline',
                midClick: true,
                showCloseBtn: false,
                callbacks: {
                    beforeOpen: function() {
                        
                        if(typeItem == 'video') {

                            var idVideo = currItem.data('key-gallery-item');
                            
                            $.ajax({
                                url: '/api/gallery.video.player/?id='+idVideo,
                                dataType: 'html',
                                beforeSend: function(){
                                    content.html('<div data-loader="true">'+
                                            '<div class="loader-item">'+
                                                '<div class="sk-fading-circle">'+
                                                    '<div class="sk-circle1 sk-circle"></div>'+
                                                    '<div class="sk-circle2 sk-circle"></div>'+
                                                    '<div class="sk-circle3 sk-circle"></div>'+
                                                    '<div class="sk-circle4 sk-circle"></div>'+
                                                    '<div class="sk-circle5 sk-circle"></div>'+
                                                    '<div class="sk-circle6 sk-circle"></div>'+
                                                    '<div class="sk-circle7 sk-circle"></div>'+
                                                    '<div class="sk-circle8 sk-circle"></div>'+
                                                    '<div class="sk-circle9 sk-circle"></div>'+
                                                    '<div class="sk-circle10 sk-circle"></div>'+
                                                    '<div class="sk-circle11 sk-circle"></div>'+
                                                    '<div class="sk-circle12 sk-circle"></div>'+
                                                '</div>'+
                                            '</div>'+
                                        '</div>');
                                        
                                },
                                success: function(_data){
                                    content.html(_data);
                                }
                            });
                        }
                    },
                    close: function(){
                        if((typeItem == 'video')&&(content.find('.bx-video').length)) {
                            var id = $(content.children().get(0)).attr('id');
                            jwplayer(id).stop();
                        }
                    }
                }
            });
        },
        addDataAjax: function(btnMore) {
            var typeLoadMore = btnMore.data('btn-load-more'),
                container = $('[data-container-load-more="'+typeLoadMore+'"]'),
                galleryId = btnMore.data('gallery-id'),
                title = '',
                innerContent = '';

            $.ajax({
                url: '/api/gallery.' + typeLoadMore + '/',
                data: {
                    gallery: galleryId,
                    page: currPageGalleryDetail + 1
                },
                dataType: 'json',
                type: 'POST',
                beforeSend: function(){},
                success: function(_data){

                    currPageGalleryDetail++;
                    
                    if(currPageGalleryDetail >= _data.pagesCount) {
                        btnMore.hide();
                    }

                    if(_data.list.length > 0){

                        _data.list.forEach(function(item, i){
                            container.append(item.html);
                        });
                    }

                    PressCenter.Gallery.initPhotoDetail();
                }
            });
        },
        initPhotoDetail: function() {
            let fancyboxPhotoDetail = $('[data-fancybox-photo-detail]');
            if(fancyboxPhotoDetail.length) {

                var linkPhotoDetail = fancyboxPhotoDetail.find('[data-fancybox]');
                linkPhotoDetail.fancybox({
                    loop : false,
                    margin : 0,
                    arrows : true,
                    infobar : false,
                    toolbar : false,
                    baseClass: 'fancybox-photo-detail',
                    transitionEffect : "slide",
                    animationEffect: "fade",
                    animationDuration: 0,
                    hash : null,
                    buttons : [
                        'close'
                    ],
                    btnTpl: {
                        smallBtn:
                            '<button data-fancybox-close class="fancybox-close-small"><span class="fancybox-close-small__text">Закрыть</span> <span class="svg-icon svg-icon_close"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-close"></use></svg></span></button>',

                        arrowLeft:
                            '<a data-fancybox-prev class="fancybox-button fancybox-button_arrow-left" href="javascript:;"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></a>',

                        arrowRight:
                            '<a data-fancybox-next class="fancybox-button fancybox-button_arrow-right" href="javascript:;"><span class="svg-icon"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg></span></a>'
                    }
                });
            }  
        }
    }
}

$(document).ready(function ($) {

    let mobileSliderWallet = $('[data-mobile-slider-arhive-wallet]');
    if(mobileSliderWallet.length){

        mobileSliderWallet.each(function() {
            PressCenter.Wallet.initSlider($(this));
        });

        $('[data-tabs]').on('click', '[data-item-nav-tabs]', function(e){
            if(Media.detect().isMobile){
                var _this = $(this),
                    value = _this.data('item-nav-tabs'),
                    currSlider = $('[data-tab-pane="' + value + '"]').find('[data-mobile-slider-arhive-wallet]');

                if(currSlider.hasClass('slick-slider')){
                    currSlider.slick('unslick');
                    PressCenter.Wallet.initSlider(currSlider);
                }
            }
        });
    }

    let btnLoadMoreGallery = $('[data-btn-load-more]');
    if(btnLoadMoreGallery.length) {

        btnLoadMoreGallery.on('click', function(){
            var _this = $(this);                

            PressCenter.Gallery.addDataAjax(_this);
        });
    }

    $('body').on('click', '[data-btn-gallery-popup]', function(){
        var _this = $(this);

        PressCenter.Gallery.initPopupVideo(_this);
    });

    PressCenter.Gallery.initPhotoDetail();

});



// WEBPACK FOOTER //
// ./components/press-center.js